import { WIZARD } from '../../constants/sessionStorage';
import {
  retrieveFromSessionStorage,
  storeInSessionStorage,
} from './sessionStorageHelper';

export function setWizardContent(key, value) {
  const data = retrieveFromSessionStorage(WIZARD);
  const newData = { ...data, [key]: value };
  storeInSessionStorage(WIZARD, newData);
}

export function getWizardContent(key) {
  if (retrieveFromSessionStorage(WIZARD)) {
    return retrieveFromSessionStorage(WIZARD)[key];
  }
}
